import { useState, useCallback } from "react"
import PropTypes from "prop-types"
import { useResourceCurrency } from "resources/currencies"
import { useModelMetadata } from "resources/models"
import { usePositionSetMetadata } from "resources/position-sets"
import AiTeammate from "../.."
import { ToggleButton } from "./toggle-button"

export function AiTeammateButtonContent({ size, className, context }) {
  const [isOpen, setIsOpen] = useState(false)

  const {
    modelId,
    instrument,
    base,
    startDate,
    endDate,
    isPreferencesLoaded,
  } = context

  const [modelMetadata] = useModelMetadata(modelId)
  const [resourceMetadata] = usePositionSetMetadata(modelId, instrument, modelMetadata?.availability?.currentDate)
  const [benchmarkMetadata] = usePositionSetMetadata(modelId, base, modelMetadata?.availability?.currentDate)
  const [currency] = useResourceCurrency(modelId, instrument)

  const handleToggle = useCallback(() => {
    setIsOpen(prev => !prev)
  }, [])

  const handleDrawerClose = useCallback(() => {
    setIsOpen(false)
  }, [])

  return (
    <>
      <ToggleButton
        size={size}
        className={className}
        disabled={!isPreferencesLoaded}
        tooltip={`AI Teammate${!isPreferencesLoaded ? " (Loading...)" : ""}`}
        onClick={handleToggle}
      />
      <AiTeammate
        isOpen={isOpen}
        onClose={handleDrawerClose}
        modelId={modelId}
        instrument={instrument}
        base={base}
        modelMetadata={modelMetadata}
        resourceMetadata={resourceMetadata}
        benchmarkMetadata={benchmarkMetadata}
        currency={currency}
        startDate={startDate}
        endDate={endDate}
      />
    </>
  )
}

AiTeammateButtonContent.propTypes = {
  size: PropTypes.oneOf(["small", "medium"]),
  className: PropTypes.string,
  context: PropTypes.shape({
    modelId: PropTypes.string,
    instrument: PropTypes.string,
    base: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    isPreferencesLoaded: PropTypes.bool,
  }).isRequired,
}
